import { Component, OnDestroy, OnInit } from '@angular/core';
import { BookingSlotStateService } from '../../services/booking-slot-state.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-time-slot-navigation',
  templateUrl: './time-slot-navigation.component.html',
  styleUrls: ['./time-slot-navigation.component.css']
})
export class TimeSlotNavigationComponent implements OnInit, OnDestroy {

  private _shiftSlotSubscription: Subscription;

  constructor(
    private bookingSlotStateService: BookingSlotStateService,
    public loadingSpinnerService: LoadingSpinnerService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this._unsubscribeShiftSlotSubscription();
  }

  get isLoading(): boolean {
    return this.loadingSpinnerService.hasSpinner;
  }

  onNextSlot() {
    this.shiftSlot(1);
  }

  onPrevSlot() {
    this.shiftSlot(-1);
  }

  shiftSlot(offset: number): void {
    if (this.isLoading) {
      return;
    }
    this._unsubscribeShiftSlotSubscription();
    this._shiftSlotSubscription = this.bookingSlotStateService.shiftSlot(offset).subscribe();
  }

  _unsubscribeShiftSlotSubscription(): void {
    if (this._shiftSlotSubscription) {
      this._shiftSlotSubscription.unsubscribe();
      this._shiftSlotSubscription = null;
    }
  }
}
